<app-info-page
  title="{{ 'Geofence' }}"
  [isComponentOrProject]="'PROJECT'"
>
  @if (dualSolutionAvailable) {
  <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="solution-tabs grey-bg">
    @for (link of links; track link.id) {
    <a mat-tab-link (click)="changeSolutionSpace(link.id)" [active]="activeLink === link.id">
      {{ link.label }}
    </a>
    }
  </nav>
  }
  <mat-tab-nav-panel #tabPanel class="solution-panel" [attr.role]="dualSolutionAvailable ? 'tabpanel' : null">
    @if (isGeoFenceLoaded) {
    <div class="content-container" [class.drawer-open]="bp.isCompact() && isDrawerOpen">
      <div class="table-section" [class.drawer-closed]="bp.isCompact() && !isDrawerOpen">
        <div class="geofence-table-container">
          <table mat-table [dataSource]="dataSource" class="geofence-table">
            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Name</th>
              <td mat-cell *matCellDef="let geofence">{{ geofence.name }}</td>
            </ng-container>
            <!-- Description Column -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef>Description</th>
              <td mat-cell *matCellDef="let geofence">{{ geofence.description }}</td>
            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let geofence">
                <div class="actions-container">
                  <button
                    mat-icon-button
                    class="delete-button"
                    (click)="onDeleteClicked(geofence, $event)"
                    aria-label="Delete geofence"
                  >
                    <mat-icon class="delete-icon">delete</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="menu"
                    (click)="$event.stopPropagation()"
                    aria-label="More options"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onServiceLocationClicked(geofence)">
                      <mat-icon>settings</mat-icon>
                      <span>Manage Service Location</span>
                    </button>
                  </mat-menu>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              (click)="onRowClicked(row)"
              [class.selected-row]="selectedGeofence?.id === row.id"
              class="table-row"
            ></tr>
          </table>
        </div>
        @if (dataSource.length === 0) {
        <div class="no-data-message">
          <h2>No geofence available</h2>
        </div>
        }
      </div>
      <div class="map-section">
        <app-zx-geofence-map
          [selectedGeofence]="selectedGeofence"
          [isLoadingComponents]="isLoadingComponents"
          [components]="componentsInGeofence"
          [solution]="solutionSpace"
          (clearSelection)="onClearSelection()"
        >
        </app-zx-geofence-map>
      </div>
      @if (bp.isCompact()) {
      <!-- the same handle as the other map pages: on the map's left edge, or on the drawer's right edge while open -->
      <button
        type="button"
        class="btn-toggle"
        [class.drawer-open]="isDrawerOpen"
        [attr.aria-expanded]="isDrawerOpen"
        aria-label="Toggle geofence list"
        (click)="toggleDrawer()"
      >
        <svg-icon
          [src]="isDrawerOpen ? '/assets/icons/icon-40-collapse.svg' : '/assets/icons/icon-40-expand.svg'"
          [class]="'icon-mobile'"
        ></svg-icon>
      </button>
      }
    </div>
    }
  </mat-tab-nav-panel>
</app-info-page>
